import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
// import pdfMake from 'pdfmake/build/pdfmake';
import {
	clearAdvanceFilter,
	setAdvanceFilter,
	setAdvanceFilterPage,
	setAdvanceFilterTotalPage,
	setSelectedInput,
	setSelectedInputData,
	setSelectedInputValue,
} from '../../../../../store/action/advanceFilter';
import { getDate } from '../../../../../utils/dateUtils';
import { getFiltersParams } from '../../../../../helper';
import { toast } from 'react-toastify';
import {
	fetchCreditNoteList,
	generateSalesCreditNotePdf,
} from '../../../../../services/sales_credit_note';
import { hasPermission } from '../../../../../utils/controller';
// import { generateCreditNotePdf } from '../components/generateCreditNotePdf';

const UseCreditNote = () => {
	const [bulkAction, setBulkAction] = useState([]);
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const [deselectRows, setDeselectRows] = useState(null);
	const [headerDropDown, setHeaderDropDown] = useState('All Credit Note');
	const [sortDirection, setSortDirection] = useState({ id: 'asc' });
	const suburl = localStorage.getItem('suburl');
	const dispatch = useDispatch();
	const {
		page: advanceFilterPage,
		totalPages: advanceFilterTotalPages,
		pageSize: advanceFilterPageSize,
		orderBy: advanceFilterOrderby,
		sortBy: advanceFilterSortBy,
		selectedInputs,
		isAdvanceFilterApplied,
	} = useSelector((state) => state.advanceFilter);
	const [creditNote, setCreditNote] = useState({
		data: [],
		totalPages: 0,
		currentPage: 1,
	});
	const [creditNoteParams, setCreditNoteParams] = useState({
		page: 1,
		page_size: 20,
		order_by: 'desc',
		sort_by: 'created_at',
		filters: {},
	});
	const [isLoading, setLoading] = useState(false);
	const [isLoader, setLoader] = useState(false);
	const navigate = useNavigate();
	const [isAdvanceFilterOpen, setIsAdvanceFilterOpen] = useState(false);
	const handleDeselectAll = (deselectAllRowsFn) => {
		setDeselectRows(() => deselectAllRowsFn);
	};
	const handlePageChange = (page) => {
		if (isAdvanceFilterApplied) {
			dispatch(setAdvanceFilterPage({ page }));
		} else {
			setCreditNoteParams((prev) => ({
				...prev,
				page,
			}));
		}
	};

	const onRowClick = (id) => {
		if (id && hasPermission('sales.credit_notes.view', user?.role?.role_permissions)) {
			navigate(`/user/${suburl}/sales/credit-note-details/${id}`);
		}
	};
	const FilterDatalist = (dropDownData) => {
		if (isAdvanceFilterApplied && dropDownData === 'All Credit Note') {
			dispatch(clearAdvanceFilter());
			setHeaderDropDown('All Invoices');
			return;
		}
		if (dropDownData === 'Customer Name') {
			dispatch(setSelectedInput({ key: 'customer_name', label: 'Customer Name' }));
			dispatch(setAdvanceFilter({ isAdvanceFilterApplied: true }));
			return;
		}

		setHeaderDropDown(dropDownData);
		const updatedSelectedInput = selectedInputs.map((input) => {
			if (input.key === 'status') {
				return {
					...input,
					value: dropDownData,
				};
			}
			return input;
		});
		dispatch(setSelectedInput({ key: 'status', label: 'Status' }));
		dispatch(setSelectedInputValue({ key: 'status', value: dropDownData }));
		dispatch(setAdvanceFilter({ isAdvanceFilterApplied: true }));
		var selectInputData = [
			{ key: 'is_open', value: 'Open' },
			{ key: 'is_closed', value: 'Close' },
		];
		dispatch(setSelectedInputData({ key: 'status', data: selectInputData }));
		const params = getFiltersParams(updatedSelectedInput);
		handleApplyFilters(params);
	};
	const sortDataList = (param) => {
		const newDirection = sortDirection[param.sort_by] === 'desc' ? 'asc' : 'desc';
		setSortDirection({ [param.sort_by]: newDirection });
		if (isAdvanceFilterApplied) {
			dispatch(setAdvanceFilter({ order_by: newDirection, sort_by: param.sort_by }));
			const params = getFiltersParams(selectedInputs);
			handleApplyFilters(params);
		} else {
			setCreditNoteParams((prev) => ({
				...prev,
				order_by: newDirection,
				sort_by: param.sort_by,
			}));
		}
	};
	async function handleOnFocusSelectedFilterInput(key) {
		let selectInputData = [];
		if (key !== 'status') {
			const { credit_notes } = await fetchCreditNoteList({
				...creditNoteParams,
				page_size: 1000,
			});
			if (key === 'customer_name') {
				selectInputData = credit_notes
					?.filter((item) => item['customer'])
					?.map((pr) => ({
						key: pr?.customer?.name,
						value: pr?.customer?.name,
					}));
			} else if (key === 'credit_note_type') {
				selectInputData = [
					{ key: 1, value: 'Damaged/Return Goods' },
					{ key: 2, value: 'Excess Payment' },
					{ key: 3, value: 'Advance Payment' },
				];
			} else {
				selectInputData = credit_notes
					?.filter((item) => item[key])
					?.map((pr) => ({
						key: pr[key],
						value: pr[key],
					}));
			}
		} else {
			selectInputData = [
				{ key: 'is_open', value: 'Open' },
				{ key: 'is_closed', value: 'Close' },
			];
		}
		dispatch(setSelectedInputData({ key, data: selectInputData }));
	}
	async function handleApplyFilters(params) {
		try {
			if (Object.keys(params).length === 0) {
				return;
			}
			if (params.status) {
				setHeaderDropDown(params.status);
			}
			const updatedParams = { ...params };

			if (updatedParams.status === 'Customer Name') {
				updatedParams.status = 'customer_name';
			}
			if (updatedParams.status === 'Open') {
				updatedParams.status = 'is_open';
			}
			if (updatedParams.status === 'Close') {
				updatedParams.status = 'is_closed';
			}

			var { credit_notes, total_pages } = await fetchCreditNoteList({
				order_by: advanceFilterOrderby,
				sort_by: advanceFilterSortBy,
				page: advanceFilterPage,
				page_size: advanceFilterPageSize,
				filters: updatedParams,
			});
			const creditNoteLists = mappedTableData(credit_notes);
			setBulkAction([]);
			setCreditNote((prev) => ({
				...prev,
				data: creditNoteLists,
				totalPages: total_pages,
				currentPage: 1,
			}));
			dispatch(setAdvanceFilterTotalPage({ totalPages: total_pages }));
			setIsAdvanceFilterOpen(false);
		} catch (error) {
			toast.error(error?.message || 'Something went wrong! Try again.');
		}
	}
	async function searchSelectedInputItems(key, value) {
		try {
			let optionsList;
			if (key === 'status') {
				optionsList = [
					{ key: 'is_open', value: 'open' },
					{ key: 'is_closed', value: 'close' },
				];
			} else {
				const { credit_notes } = await fetchCreditNoteList({
					page_size: 1000,
					filters: {
						key: value,
					},
				});
				optionsList = credit_notes?.map((pr) => ({
					key: pr[key],
					value: pr[key],
				}));
			}
			dispatch(setSelectedInputData({ key, data: optionsList }));
		} catch (error) {}
	}

	// async function handlePrintAndDownloadPdf(isPrint) {
	// 	setLoader(true);
	// 	const mergedDocDefinition = await generateCreditNotePdf(bulkAction);
	// 	if (isPrint) {
	// 		pdfMake.createPdf(mergedDocDefinition).print();
	// 	} else {
	// 		pdfMake.createPdf(mergedDocDefinition).download();
	// 	}
	// 	setLoader(false);
	// }

	async function handlePrintAndDownloadPdf(
		ids = bulkAction.join(','),
		type = 'print',
		merge = false,
	) {
		try {
			setLoader(true);
			const pdf_details = await generateSalesCreditNotePdf(
				ids === '' ? bulkAction.join(',') : ids,
				merge,
			);
			const url = pdf_details.signed_url;

			if (type === 'print') {
				window.open(url, '_blank');
				return;
			}

			if (type === 'download') {
				const fileName = `${merge ? 'merged' : pdf_details?.meta_data.credit_note_number}_sales_credit_note_${Date.now()}.pdf`;
				const response = await fetch(url);
				const blob = await response.blob();
				const blobUrl = window.URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = blobUrl;
				link.download = fileName;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				window.URL.revokeObjectURL(blobUrl);
			}
		} catch (err) {
		} finally {
			setLoader(false);
		}
	}

	const getCreditNotes = async () => {
		try {
			setLoading(true);
			var { credit_notes, total_pages, page } = await fetchCreditNoteList(creditNoteParams);
			const creditNoteList = mappedTableData(credit_notes);
			setBulkAction([]);
			setCreditNote((prev) => ({
				...prev,
				data: creditNoteList,
				totalPages: total_pages,
				currentPage: page,
			}));
			setLoading(false);
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		}
	};

	function mappedTableData(data) {
		return data?.map((ele) => {
			return {
				id: ele.id,
				DATE: getDate(ele.date),
				'CREDIT NOTE #': ele?.credit_note_number || 'N/A',
				'CUSTOMER NAME': ele.customer?.name || 'N/A',
				STATUS: ele?.status,
				TYPE:
					ele?.credit_note_type === 1
						? 'Damaged/Return Goods'
						: ele?.credit_note_type === 2
							? 'Excess Payment'
							: 'Advance Payment',
				'CREDIT APPLIED': Number(ele?.total_paid_amount || 0).toFixed(2),
				'AVAILABLE CREDIT':
					Number(ele?.total_credit_amount) - Number(ele?.total_paid_amount || 0) ?? 0,
				AMOUNT: Number(ele?.total_credit_amount).toFixed(2),
			};
		});
	}
	useEffect(() => {
		if (isAdvanceFilterApplied) {
			const params = getFiltersParams(selectedInputs);
			handleApplyFilters(params);
		} else {
			getCreditNotes();
		}
	}, [creditNoteParams, advanceFilterPage, isAdvanceFilterApplied]);
	return {
		user,
		creditNote,
		creditNoteParams,
		onRowClick,
		isLoading,
		bulkAction,
		navigate,
		suburl,
		setBulkAction,
		deselectRows,
		FilterDatalist,
		dispatch,
		headerDropDown,
		setHeaderDropDown,
		isAdvanceFilterApplied,
		setIsAdvanceFilterOpen,
		sortDataList,
		sortDirection,
		advanceFilterPage,
		advanceFilterTotalPages,
		handleOnFocusSelectedFilterInput,
		handleApplyFilters,
		searchSelectedInputItems,
		isAdvanceFilterOpen,
		selectedInputs,
		handleDeselectAll,
		handlePageChange,
		setCreditNoteParams,
		handlePrintAndDownloadPdf,
	};
};
export default UseCreditNote;
